import React from 'react';
import { Link } from 'react-router-dom';
import { CampaignPackagesAdmin } from '../components/admin/CampaignPackagesAdmin';
import { AdminPaymentsByCampaign } from '../components/admin/AdminPaymentsByCampaign';
import { useAuth } from '../hooks/useAuth';
import { isOwnerAdmin } from '../utils/adminPermissions';

const AdminCampaignPackagesPage: React.FC = () => {
  const { user } = useAuth();
  const isFullAdmin = isOwnerAdmin(user);

  if (!isFullAdmin) {
    return (
      <main className="mx-auto max-w-2xl px-4 py-10">
        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-4 py-5 text-sm text-slate-900 dark:text-slate-100 shadow-sm">
          <h1 className="text-base font-semibold text-slate-900 dark:text-slate-100">Full admin access required</h1>
          <p className="mt-2 text-xs text-slate-700 dark:text-slate-300">
            Campaign packages can only be edited by full administrators. Ask a full admin to
            adjust packages or pricing for you.
          </p>
          <div className="mt-4 flex gap-2 text-xs">
            <Link
              to="/admin"
              className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Back to admin overview
            </Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="mx-auto max-w-6xl px-4 py-8 space-y-6">
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold text-slate-900 dark:text-slate-100">Campaign packages</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Configure the packages and price ranges advertisers see at checkout.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/admin"
            className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Admin overview
          </Link>
          <Link
            to="/"
            className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Go home
          </Link>
        </div>
      </header>

      <section className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <CampaignPackagesAdmin />
      </section>

      <section className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <AdminPaymentsByCampaign />
      </section>
    </main>
  );
};

export default AdminCampaignPackagesPage;
